import { render, staticRenderFns } from "./facilityList.vue?vue&type=template&id=67b51289&scoped=true"
import script from "./facilityList.vue?vue&type=script&lang=js"
export * from "./facilityList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b51289",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67b51289')) {
      api.createRecord('67b51289', component.options)
    } else {
      api.reload('67b51289', component.options)
    }
    module.hot.accept("./facilityList.vue?vue&type=template&id=67b51289&scoped=true", function () {
      api.rerender('67b51289', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/RMC/Protein/ASL/facilityList.vue"
export default component.exports